import { SubscriptionStoreState, useSubscriptionStore } from '../subscriptionStore';
import { getHasHdWords } from './getHasHdWords';
import { getIsPremium } from './getIsPremium';

export const getHasAccessToPremiumVoice = (state?: SubscriptionStoreState): boolean => {
  const latestState = state ?? useSubscriptionStore.getState();
  const isPremium = getIsPremium(latestState);
  const hasHdWords = getHasHdWords(latestState);

  // I want to err on the side of caution and return true if the user is premium and the subscription is loading
  if (isPremium && latestState?.isLoading) return true;

  return isPremium && hasHdWords;
};
